import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "25",
  viewBox: "0 0 24 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M15.12 5.57288H17V2.2751C16.0897 2.17694 15.1751 2.12848 14.26 2.12991C11.54 2.12991 9.67999 3.8514 9.67999 7.00399V9.72102H6.60999V13.4129H9.67999V22.8707H13.36V13.4129H16.42L16.88 9.72102H13.36V7.36695C13.36 6.27806 13.64 5.57288 15.12 5.57288Z",
  fill: "white"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }